import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import MDBox from "shared/components/MDBox";
import MDTypography from "shared/components/MDTypography";
import DashboardLayout from "app/layout/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/layout/DashboardNavbar";
import Footer from "app/layout/Footer";
import LockIcon from "@mui/icons-material/Lock";

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        minHeight="80vh"
        textAlign="center"
        p={3}
      >
        <MDBox mb={3} color="error">
          <LockIcon sx={{ fontSize: "5rem" }} />
        </MDBox>

        <MDBox mb={2}>
          <MDTypography variant="h1" fontWeight="bold" color="error">
            403
          </MDTypography>
        </MDBox>

        <MDBox mb={2}>
          <MDTypography variant="h3" fontWeight="medium">
            Acceso no autorizado
          </MDTypography>
        </MDBox>

        <MDBox mb={4} maxWidth="600px">
          <MDTypography variant="body1" color="text">
            No tienes los permisos necesarios para acceder a esta página. Por favor contacta al
            administrador del sistema o inicia sesión con una cuenta diferente.
          </MDTypography>
        </MDBox>

        <MDBox display="flex" gap={2}>
          <Button
            variant="gradient"
            color="info"
            size="large"
            onClick={() => navigate("/")}
            sx={{
              borderRadius: "12px",
              padding: "12px 24px",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
              "&:hover": {
                transform: "translateY(-2px)",
                boxShadow: "0 6px 8px rgba(0, 0, 0, 0.15)",
              },
              transition: "all 0.3s ease",
            }}
          >
            <MDTypography variant="button" color="white" fontWeight="medium">
              Volver al inicio
            </MDTypography>
          </Button>

          <Button
            variant="outlined"
            color="dark"
            size="large"
            onClick={() => navigate("/authentication/sign-in")}
            sx={{
              borderRadius: "12px",
              padding: "12px 24px",
              borderWidth: "2px",
              "&:hover": {
                borderWidth: "2px",
                transform: "translateY(-2px)",
                boxShadow: "0 6px 8px rgba(0, 0, 0, 0.1)",
              },
              transition: "all 0.3s ease",
            }}
          >
            <MDTypography variant="button" fontWeight="medium">
              Iniciar sesión
            </MDTypography>
          </Button>
        </MDBox>

        <MDBox mt={6} width="100%" maxWidth="400px">
          <img
            src="https://cdn.dribbble.com/users/1192256/screenshots/6290585/1._friday_____forbidden_403.png"
            alt="403 error"
            style={{ width: "100%", borderRadius: "12px" }}
          />
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default Unauthorized;
